<template>
  <div>
    <base-card>
      <div class="success-container d-flex align-center">
        <div class="col-xs-8 pt_25 mt_30 mb_25 success-icon-container">
          <i class="success-icon far fa-check-circle" />
        </div>
        <div class="success-text mt_10 col-xs-8">
          <p class="text-center">Módulo removido com sucesso!</p>
          <p class="text-center">A partir de agora o valor mensal da sua assinatura será:</p>
          <p class="text-center module-price">R$ 59,90</p>
        </div>
      </div>
      <div class="mt_10 py_30 d-flex justify-center">
        <div class="col-xs-8 d-flex align-stretch success-link-container">
          <base-button text="IR PARA MINHA CONTA" @click="closeDrawer" />
        </div>
      </div>
    </base-card>
  </div>
</template>
<script>
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseButton, BaseCard },
  methods: {
    closeDrawer() {
      this.$emit("close");
    }
  }
};
</script>
<style scoped>
.success-container {
  flex-direction: column;
}

.success-link-container .btn {
  flex: 1;
}

.success-container .success-icon-container {
  text-align: center;
}

.success-container .success-icon-container .success-icon {
  font-size: 80px;
  color: #0099ffcc;
}

.success-text p {
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.success-text .module-price {
  font: normal normal bold 16px/19px Lato;
  letter-spacing: 0px;
}
</style>